/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Address information
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line2: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line3?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof AddressDto
     */
    zipCode: string;
    /**
     * City name
     * @type {string}
     * @memberof AddressDto
     */
    city: string;
    /**
     * Country name
     * @type {string}
     * @memberof AddressDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    formattedAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof AddressDto
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof AddressDto
     */
    longitude?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    googlePlaceId?: string;
}

/**
 * Check if a given object implements the AddressDto interface.
 */
export function instanceOfAddressDto(value: object): value is AddressDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('line2' in value) || value['line2'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function AddressDtoFromJSON(json: any): AddressDto {
    return AddressDtoFromJSONTyped(json, false);
}

export function AddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'],
        'line2': json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'googlePlaceId': json['googlePlaceId'] == null ? undefined : json['googlePlaceId'],
    };
}

export function AddressDtoToJSON(json: any): AddressDto {
    return AddressDtoToJSONTyped(json, false);
}

export function AddressDtoToJSONTyped(value?: AddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'formattedAddress': value['formattedAddress'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'googlePlaceId': value['googlePlaceId'],
    };
}

